import { gql } from '@apollo/client';

export const CREATE_AUTO_MUTATION = gql`
  mutation CreateAuto($autoCreateDto: AutoCreateDto!) {
    createAuto(autoCreateDto: $autoCreateDto) {
      id
      institutionName
      email
      createdDt
    }
  }
`;
